import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ScoringMethodPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ScoringMethodPopup" */ './Container'),
  'popup'
);
